module.exports = __webpack_public_path__ + "img/white-logo.6c58147f.png";